import type {
    ImageEffectType,
    OpenAiImageEditType,
    OpenAiTextToImageType
} from '@/typings/customilyElements/imageEffectType';
import { EffectType } from '@/typings/customilyElements/imageEffectType';
import { upgradeLegacyOpenRouterImageEdit } from '@/components/DesignStudio/ImageEffectsProperties/utils/openRouterImageToImage';
import { normalizeOpenRouterImageParams } from '@/components/DesignStudio/ImageEffectsProperties/core/openrouter';
import {
    resolveOpenAIBackground,
    resolveOpenAIModel
} from '@/components/DesignStudio/ImageEffectsProperties/utils/effectCreators';

const OPENROUTER_IMAGE_EFFECTS: EffectType[] = [
    EffectType.OPENROUTER_IMAGE_TO_IMAGE,
    EffectType.OPENROUTER_TEXT_TO_IMAGE
];

const OPENAI_IMAGE_EFFECTS: EffectType[] = [EffectType.OPENAI_IMAGE_EDIT, EffectType.OPENAI_TEXT_TO_IMAGE];

// Applied when the editor opens a saved effect, so saving persists the fix for legacy/deprecated rows.
export const upgradeSavedImageEffect = (effect: ImageEffectType): ImageEffectType => {
    const upgraded = upgradeLegacyOpenRouterImageEdit(effect);
    if (OPENROUTER_IMAGE_EFFECTS.includes(upgraded.type)) return normalizeOpenRouterImageParams(upgraded);
    if (OPENAI_IMAGE_EFFECTS.includes(upgraded.type))
        return resolveOpenAIBackground(resolveOpenAIModel(upgraded as OpenAiImageEditType | OpenAiTextToImageType));
    return upgraded;
};

export const mergeImageEffectUpdate = (effect: ImageEffectType, newData?: ImageEffectType): ImageEffectType => {
    if (!newData) return effect;
    // OpenRouter forms emit the whole effect for its model; merging would leak params of a previous one.
    if (!OPENROUTER_IMAGE_EFFECTS.includes(effect.type)) return { ...effect, ...newData } as ImageEffectType;

    // Forms in the create flow never receive the effect's identity, so it always comes from the saved effect.
    return { ...newData, id: effect.id, presetId: effect.presetId, type: effect.type } as ImageEffectType;
};
